
import React from "react";
import {Zoom} from 'react-reveal';
import useAuth from "../../Hooks/useAuth";
import User from "../individual/User";

const ArtistsItem = ({ artistsData }) => {
  const { id,artistsName, price, artistsUser, image, status } = artistsData;
  const {showDummyImage} = useAuth()
  return (
    <Zoom big duration={1500}>
        <div className="artists-item">
      <div className="artists-item-img">
        <img
          src={require(`${process.env.REACT_APP_ARTIST_IMAGE}${image}`)}
          alt={image}
          onError={({currentTarget},imageSize='270X110')=>showDummyImage({currentTarget},imageSize)}
        />
      </div>
      <div className="artists-profile">
        <User
          pic={require(`${process.env.REACT_APP_USER_IMAGE}${artistsUser}`)}
          status={status}
          id={id}
          showDummyImage={showDummyImage}
          resulution={'68X68'}
        />
      </div>
      <div className="artists-item-content">
        <h5>{artistsName}</h5>
        <span>{price}</span>
      </div>
        </div>
    </Zoom>
  );
};

export default ArtistsItem;
